'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _package = require('../../../package.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var styles = require('./Footer.scss');
      var currentDate = new Date();
      return _react2.default.createElement(
        'div',
        { className: styles.footer, id: 'footer' },
        _react2.default.createElement(
          'div',
          { className: styles.advertiseApp },
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  {
                    md: 8,
                    className: styles.noPaddingLeft + ' ' + styles.adApp
                  },
                  _react2.default.createElement(
                    'div',
                    {
                      className: styles.adAppContent
                      // ' ' +
                      // (user ? styles.userAdAppContent : '')

                    },
                    _react2.default.createElement(
                      'div',
                      { className: styles.adTitle },
                      'LOOKME PHI\xCAN B\u1EA2N APP CHO KH\xC1CH H\xC0NG V\xC0 CH\u1EE6 SHOP'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.adText },
                      'H\xE3y nhanh tay t\u1EA3i Lookme \u0111\u1EC3 c\xF3 nh\u1EEFng tr\u1EA3i nghi\u1EC7m th\xFA v\u1ECB v\u1EC1 l\xE0m \u0111\u1EB9p nh\xE9'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.buttonStore },
                      _react2.default.createElement(
                        'a',
                        {
                          target: '_blank',
                          href: 'https://apps.apple.com/vn/app/lookme-%C4%91%E1%BA%B7t-l%E1%BB%8Bch-l%C3%A0m-%C4%91%E1%BA%B9p/id1447215019'
                        },
                        _react2.default.createElement('i', {
                          className: 'fa fa-apple fa-3x ' + styles.buttonAppStore
                        })
                      ),
                      _react2.default.createElement(
                        'a',
                        {
                          target: '_blank',
                          href: 'https://play.google.com/store/apps/details?id=com.lookme.client&hl=en'
                        },
                        _react2.default.createElement('i', {
                          className: 'fa fa-android fa-3x ' + styles.buttonGooglePlay
                        })
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: styles.mobileAppImg })
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 4, className: styles.noPaddingRight },
                  _react2.default.createElement(
                    'div',
                    { className: styles.adReg },
                    _react2.default.createElement(
                      'div',
                      { className: styles.adRegTitle },
                      'H\u1EE2P T\xC1C C\xD9NG LOOKME'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.adRegText },
                      'Qu\u1EA3n l\xFD v\u1EADn h\xE0nh v\xE0 qu\u1EA3ng b\xE1 spa/salon hi\u1EC7u qu\u1EA3 c\xF9ng',
                      ' ',
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Lookme'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/bang-gia' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.buttonReg },
                        'T\xCCM HI\u1EC2U'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.footerReference },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              _reactBootstrap.Grid,
              null,
              _react2.default.createElement(
                _reactBootstrap.Row,
                null,
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 3, className: styles.referenceCol },
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceTitle },
                    'Gi\u1EDBi thi\u1EC7u'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceLink },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/gioi-thieu' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'V\u1EC1 Lookme'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/thong-tin-lien-he' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Th\xF4ng tin li\xEAn h\u1EC7'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/dieu-khoan' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110i\u1EC1u kho\u1EA3n'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/quy-che-hoat-dong' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Quy ch\u1EBF ho\u1EA1t \u0111\u1ED9ng'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/giai-quyet-tranh-chap' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Quy tr\xECnh gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/chinh-sach/bao-mat' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/dang-ki-doi-tac' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110\u0103ng k\xFD \u0111\u1ED1i t\xE1c'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 3, className: styles.referenceCol },
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceTitle },
                    'Chuy\xEAn m\u1EE5c'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceLink },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/salon-mi-va-mong' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Salon Mi v\xE0 M\xF3ng'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/spa-cham-da' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Spa Ch\u0103m Da'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/massage-va-goi-dau' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Massage G\u1ED9i \u0110\u1EA7u'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/tham-my-va-nha-khoa' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Th\u1EA9m M\u1EF9 Nha Khoa'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/salon-toc-va-make-up' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'Salon T\xF3c Make-up'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 3, className: styles.referenceCol },
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceTitle },
                    'Kh\xE1m ph\xE1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceLink },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/kham-pha?sort=prominent' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110\u1ECBa \u0111i\u1EC3m ph\u1ED5 bi\u1EBFn'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/bo-suu-tap' },
                      _react2.default.createElement(
                        'div',
                        null,
                        'B\u1ED9 s\u01B0u t\u1EADp m\u1EDBi'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/kham-pha?sort=nearby' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110\u1ECBa \u0111i\u1EC3m g\u1EA7n b\u1EA1n'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/kham-pha?sort=suggest' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110\u1ECBa \u0111i\u1EC3m g\u1EE3i \xFD'
                      )
                    ),
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/kham-pha?sort=booking' },
                      _react2.default.createElement(
                        'div',
                        null,
                        '\u0110\u1ECBa \u0111i\u1EC3m \u0111\u1EB7t l\u1ECBch'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Col,
                  { md: 3, className: styles.referenceCol },
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceTitle },
                    'C\u1ED9ng \u0111\u1ED3ng Lookme'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.referenceLink },
                    _react2.default.createElement(
                      'a',
                      {
                        href: 'https://www.facebook.com/lookmevietnam/',
                        target: '_blank'
                      },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('i', {
                          className: 'fa fa-facebook-official',
                          style: {
                            fontSize: '18px',
                            marginLeft: '2px',
                            marginRight: '8px'
                          },
                          'aria-hidden': 'true'
                        }),
                        'Facebook'
                      )
                    ),
                    _react2.default.createElement(
                      'a',
                      {
                        href: 'https://www.instagram.com/lookmevietnam/',
                        target: '_blank'
                      },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('i', {
                          className: 'fa fa-instagram',
                          style: {
                            fontSize: '18px',
                            marginLeft: '2px',
                            marginRight: '8px'
                          },
                          'aria-hidden': 'true'
                        }),
                        'Instagram'
                      )
                    ),
                    _react2.default.createElement(
                      'a',
                      {
                        href: 'https://www.youtube.com/channel/UC8uUzo03eXJ0ed_FAsY0w1Q',
                        target: '_blank'
                      },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('i', {
                          className: 'fa fa-youtube',
                          style: {
                            fontSize: '18px',
                            marginLeft: '2px',
                            marginRight: '8px'
                          },
                          'aria-hidden': 'true'
                        }),
                        'Youtube'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.copyright },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: styles.footerContent },
              _react2.default.createElement(_reactRouter.Link, { className: styles.logoCopyright, to: '/' }),
              _react2.default.createElement(
                'a',
                {
                  style: { transform: 'translate(-330px,30px) scale(0.8)' },
                  href: 'http://online.gov.vn/HomePage/WebsiteDisplay.aspx?DocId=59353'
                },
                _react2.default.createElement('img', { alt: '', title: '', src: '/BoCongThuong.png' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.textCopyright },
                _react2.default.createElement(
                  'h1',
                  null,
                  'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  '\u0110\u1ECBa ch\u1EC9 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, TP H\u1ED3 Ch\xED Minh ',
                  _react2.default.createElement('br', null),
                  'S\u1ED1 gi\u1EA5y ph\xE9p \u0110KKD 0315074848 do s\u1EDF K\u1EBF ho\u1EA1ch v\xE0 \u0110\u1EA7u T\u01B0 TPHCM c\u1EA5p ng\xE0y 28/05/2018 ',
                  _react2.default.createElement('br', null)
                ),
                'B\u1EA3n quy\u1EC1n ',
                currentDate.getFullYear(),
                ' thu\u1ED9c v\u1EC1',
                ' ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Lookme'
                ),
                ' - v',
                _package.version
              )
            )
          )
        )
      );
    }
  }]);
  return Footer;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Partials/Footer.js
// module id = 1646
// module chunks = 0